module.exports = __webpack_public_path__ + "static/media/deleteIcon.d828dc75.svg";